module.exports = __webpack_public_path__ + "static/media/nima01.8431d2d2.gif";